import { MICRO_CONVERSION, roundMicrosToNearestWholeCent } from '@/utils/money';

const MICROS_PER_CENT = MICRO_CONVERSION / 100;

export const endInX9 = (priceInMicros: number): number | null => {
  const cents = roundMicrosToNearestWholeCent(priceInMicros);
  const priceInUnits = cents / MICRO_CONVERSION;
  const newPriceInUnits = Math.floor(priceInUnits * 10) / 10 + 0.09;
  const newPriceInMicros = Math.round(newPriceInUnits * MICRO_CONVERSION);
  if (newPriceInMicros === cents) {
    return null;
  }
  return newPriceInMicros;
};

export const randomRoundUpCents = (priceInMicros: number): number | null => {
  const currentCents = Math.floor(priceInMicros / MICROS_PER_CENT) % 100;
  if (currentCents >= 99) {
    return null;
  }
  const minCents = currentCents + 1;
  const randomCents = minCents + Math.floor(Math.random() * (100 - minCents));
  const dollarPartInMicros =
    Math.floor(priceInMicros / MICRO_CONVERSION) * MICRO_CONVERSION;
  return dollarPartInMicros + randomCents * MICROS_PER_CENT;
};
